import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_13 = { class: "table table-striped table-hover" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "badge bg-info" }
const _hoisted_16 = { class: "badge bg-secondary" }
const _hoisted_17 = { class: "delivery-stats" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "row mt-3"
}
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "dataTables_info" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "pagination justify-content-end" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "custom-modal-container" }
const _hoisted_30 = { class: "custom-modal-header" }
const _hoisted_31 = { class: "header-content" }
const _hoisted_32 = { class: "header-text" }
const _hoisted_33 = { class: "header-subtitle" }
const _hoisted_34 = {
  key: 0,
  class: "custom-modal-body"
}
const _hoisted_35 = { class: "status-overview-card" }
const _hoisted_36 = { class: "status-grid" }
const _hoisted_37 = { class: "status-item" }
const _hoisted_38 = { class: "status-item" }
const _hoisted_39 = { class: "status-item" }
const _hoisted_40 = { class: "status-item" }
const _hoisted_41 = { class: "status-value category" }
const _hoisted_42 = { class: "delivery-progress-card" }
const _hoisted_43 = { class: "progress-stats" }
const _hoisted_44 = { class: "progress-stat" }
const _hoisted_45 = { class: "stat-content" }
const _hoisted_46 = { class: "stat-value" }
const _hoisted_47 = { class: "progress-stat" }
const _hoisted_48 = { class: "stat-content" }
const _hoisted_49 = { class: "stat-value delivered" }
const _hoisted_50 = { class: "progress-stat" }
const _hoisted_51 = { class: "stat-content" }
const _hoisted_52 = { class: "stat-value pending" }
const _hoisted_53 = { class: "custom-progress-bar" }
const _hoisted_54 = { class: "progress-bar-track" }
const _hoisted_55 = { class: "progress-label" }
const _hoisted_56 = { class: "info-grid" }
const _hoisted_57 = { class: "info-card" }
const _hoisted_58 = { class: "info-list" }
const _hoisted_59 = { class: "info-row" }
const _hoisted_60 = { class: "info-value" }
const _hoisted_61 = { class: "info-row" }
const _hoisted_62 = { class: "info-value tracking-id" }
const _hoisted_63 = { class: "info-row" }
const _hoisted_64 = { class: "info-value" }
const _hoisted_65 = { class: "info-row" }
const _hoisted_66 = { class: "info-value" }
const _hoisted_67 = { class: "info-card" }
const _hoisted_68 = { class: "info-list" }
const _hoisted_69 = { class: "info-row" }
const _hoisted_70 = { class: "info-value" }
const _hoisted_71 = { class: "info-row" }
const _hoisted_72 = { class: "info-value" }
const _hoisted_73 = { class: "team-section" }
const _hoisted_74 = { class: "team-grid" }
const _hoisted_75 = { class: "team-member" }
const _hoisted_76 = { class: "member-avatar requisition" }
const _hoisted_77 = { class: "member-info" }
const _hoisted_78 = { class: "member-name" }
const _hoisted_79 = { class: "member-code" }
const _hoisted_80 = {
  key: 0,
  class: "member-email"
}
const _hoisted_81 = {
  key: 0,
  class: "team-member"
}
const _hoisted_82 = { class: "member-avatar assigned" }
const _hoisted_83 = { class: "member-info" }
const _hoisted_84 = { class: "member-name" }
const _hoisted_85 = { class: "member-code" }
const _hoisted_86 = {
  key: 1,
  class: "team-member"
}
const _hoisted_87 = { class: "member-avatar delivery" }
const _hoisted_88 = { class: "member-info" }
const _hoisted_89 = { class: "member-name" }
const _hoisted_90 = { class: "member-code" }
const _hoisted_91 = { class: "timeline-section" }
const _hoisted_92 = { class: "timeline" }
const _hoisted_93 = { class: "timeline-item" }
const _hoisted_94 = { class: "timeline-content" }
const _hoisted_95 = { class: "timeline-date" }
const _hoisted_96 = {
  key: 0,
  class: "timeline-item"
}
const _hoisted_97 = { class: "timeline-content" }
const _hoisted_98 = { class: "timeline-date" }
const _hoisted_99 = { class: "timeline-status" }
const _hoisted_100 = {
  key: 1,
  class: "timeline-item"
}
const _hoisted_101 = { class: "timeline-content" }
const _hoisted_102 = { class: "timeline-date" }
const _hoisted_103 = {
  key: 2,
  class: "timeline-item"
}
const _hoisted_104 = { class: "timeline-content" }
const _hoisted_105 = { class: "timeline-date" }
const _hoisted_106 = { class: "timeline-item" }
const _hoisted_107 = { class: "timeline-content" }
const _hoisted_108 = { class: "timeline-date" }
const _hoisted_109 = {
  key: 3,
  class: "timeline-item"
}
const _hoisted_110 = { class: "timeline-content" }
const _hoisted_111 = { class: "timeline-date" }
const _hoisted_112 = {
  key: 0,
  class: "remarks-section"
}
const _hoisted_113 = { class: "remarks-content" }
const _hoisted_114 = {
  key: 1,
  class: "cancellation-alert"
}
const _hoisted_115 = { class: "alert-content" }
const _hoisted_116 = { class: "alert-message" }

import { ref, onMounted, computed } from "vue";
import * as XLSX from 'xlsx';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'order-delivery',
  setup(__props) {

const toast = useToast();
const baseUrl = process.env.VUE_APP_BASE_URL;

// State
const allData = ref<any[]>([]);
const loading = ref(false);
const currentPage = ref(1);
const elementsPerPage = ref(25);
const searchQuery = ref('');
const filters = ref({
  status: '',
  category: '',
  logStatus: ''
});
const showDetailsModal = ref(false);
const selectedItem = ref<any>(null);

// Helper function to get auth token
const getAuthToken = () => localStorage.getItem('token');

// Format date helper function
function formatDate(dateString: any) {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12;
    const hoursStr = String(hours).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hoursStr}:${minutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
}

// Badge class helpers
function getStatusBadgeClass(status: string) {
  const classes: Record<string, string> = {
    'Delivered': 'badge bg-success',
    'Partially Delivered': 'badge bg-warning',
    'Pending': 'badge bg-secondary',
    'In Progress': 'badge bg-info'
  };
  return classes[status] || 'badge bg-secondary';
}

function getPriorityBadgeClass(priority: string) {
  const classes: Record<string, string> = {
    'High': 'badge bg-danger',
    'Medium': 'badge bg-warning',
    'Low': 'badge bg-info'
  };
  return classes[priority] || 'badge bg-secondary';
}

function getLogStatusBadgeClass(status: string) {
  return status === 'Open' ? 'badge bg-primary' : 'badge bg-dark';
}

function getProgressClass(percentage: number) {
  if (percentage === 100) return 'text-success fw-bold';
  if (percentage >= 50) return 'text-warning fw-bold';
  return 'text-danger fw-bold';
}

function getProgressBarClass(percentage: number) {
  if (percentage === 100) return 'bg-success';
  if (percentage >= 50) return 'bg-warning';
  return 'bg-danger';
}

// Custom modal helper functions
function getStatusClass(status: string) {
  const classes: Record<string, string> = {
    'Delivered': 'delivered',
    'Partially Delivered': 'partial',
    'Pending': 'pending',
    'In Progress': 'progress'
  };
  return classes[status] || 'pending';
}

function getPriorityClass(priority: string) {
  const classes: Record<string, string> = {
    'High': 'high',
    'Medium': 'medium',
    'Low': 'low'
  };
  return classes[priority] || 'medium';
}

function getLogStatusClass(status: string) {
  return status === 'Open' ? 'open' : 'closed';
}

function getProgressFillClass(percentage: number) {
  if (percentage === 100) return 'complete';
  if (percentage >= 50) return 'partial';
  return 'low';
}

function getInitials(name: string | undefined) {
  if (!name) return '?';
  const parts = name.split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

// Fetch data
async function fetchOrderDeliveryData() {
  loading.value = true;
  try {
    const response = await fetch(`${baseUrl}api/admin/order-delivery-tracking-log`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (result.success) {
      allData.value = result.data || [];
      toast.success(`Loaded ${result.count} order delivery records`);
    } else {
      toast.error('Failed to fetch order delivery data');
    }
  } catch (error) {
    console.error('Error fetching order delivery data:', error);
    toast.error('Error fetching order delivery data');
  } finally {
    loading.value = false;
  }
}

// Filtered data
const filteredData = computed(() => {
  let data = [...allData.value];

  // Apply status filter
  if (filters.value.status) {
    data = data.filter(item => item.status === filters.value.status);
  }

  // Apply category filter
  if (filters.value.category) {
    data = data.filter(item => item.category === filters.value.category);
  }

  // Apply log status filter
  if (filters.value.logStatus) {
    data = data.filter(item => item.logStatus === filters.value.logStatus);
  }

  // Apply search query
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase();
    data = data.filter(item => 
      item.logNumber?.toLowerCase().includes(query) ||
      item.trackingId?.toLowerCase().includes(query) ||
      item.site?.name?.toLowerCase().includes(query) ||
      item.requisitionManager?.name?.toLowerCase().includes(query) ||
      item.orderingAssignment?.assignedTo?.name?.toLowerCase().includes(query)
    );
  }

  return data;
});

// Pagination
const totalPages = computed(() => Math.ceil(filteredData.value.length / elementsPerPage.value));
const startIndex = computed(() => (currentPage.value - 1) * elementsPerPage.value);
const endIndex = computed(() => Math.min(startIndex.value + elementsPerPage.value, filteredData.value.length));

const paginatedData = computed(() => {
  return filteredData.value.slice(startIndex.value, endIndex.value);
});

function changePage(page: number) {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
}

function applyFilters() {
  currentPage.value = 1;
}

// Actions
function refreshData() {
  fetchOrderDeliveryData();
}

function viewDetails(item: any) {
  selectedItem.value = item;
  showDetailsModal.value = true;
}

function closeDetailsModal() {
  showDetailsModal.value = false;
  selectedItem.value = null;
}

// Export to Excel
function exportToExcel() {
  try {
    const dataToExport = filteredData.value.map(item => ({
      'Log Number': item.logNumber,
      'Tracking ID': item.trackingId,
      'Site': item.site?.name || '-',
      'Category': item.category,
      'Priority': item.priority,
      'Status': item.status,
      'Log Status': item.logStatus,
      'Total Employees': item.deliveryStats.totalEmployees,
      'Delivered': item.deliveryStats.deliveredEmployees,
      'Pending': item.deliveryStats.pendingEmployees,
      'Completion %': item.deliveryStats.completionPercentage,
      'Requisition Manager': item.requisitionManager?.name || '-',
      'Manager Code': item.requisitionManager?.code || '-',
      'Assigned To': item.orderingAssignment?.assignedTo?.name || '-',
      'Assignee Code': item.orderingAssignment?.assignedTo?.code || '-',
      'Scheduled Date': formatDate(item.scheduledDeliveryDate),
      'Actual Date': formatDate(item.actualDeliveryDate),
      'Requisition Date': formatDate(item.requisitionDate),
      'Expense Type': item.expenseType,
      'Remarks': item.remarks || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Order Delivery');
    
    const fileName = `order-delivery-${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);
    
    toast.success('Data exported successfully');
  } catch (error) {
    console.error('Error exporting data:', error);
    toast.error('Error exporting data');
  }
}

// Lifecycle
onMounted(() => {
  fetchOrderDeliveryData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "card-header pb-0" }, [
            _createElementVNode("div", { class: "row" }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-6" }, [
                _createElementVNode("h5", null, "Order Delivery Tracking")
              ], -1)),
              _createElementVNode("div", { class: "col-md-6 text-end" }, [
                _createElementVNode("button", {
                  class: "btn btn-success btn-sm",
                  onClick: exportToExcel
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa fa-file-excel-o me-2" }, null, -1),
                  _createTextVNode("Export to Excel ", -1)
                ]))])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Status", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.status) = $event)),
                  class: "form-select",
                  onChange: applyFilters
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: "" }, "All Status", -1),
                  _createElementVNode("option", { value: "Delivered" }, "Delivered", -1),
                  _createElementVNode("option", { value: "Partially Delivered" }, "Partially Delivered", -1),
                  _createElementVNode("option", { value: "Pending" }, "Pending", -1)
                ]))], 544), [
                  [_vModelSelect, filters.value.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Category", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.category) = $event)),
                  class: "form-select",
                  onChange: applyFilters
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("option", { value: "" }, "All Categories", -1),
                  _createElementVNode("option", { value: "Uniform" }, "Uniform", -1),
                  _createElementVNode("option", { value: "Material" }, "Material", -1)
                ]))], 544), [
                  [_vModelSelect, filters.value.category]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Log Status", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.logStatus) = $event)),
                  class: "form-select",
                  onChange: applyFilters
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: "" }, "All", -1),
                  _createElementVNode("option", { value: "Open" }, "Open", -1),
                  _createElementVNode("option", { value: "Closed" }, "Closed", -1)
                ]))], 544), [
                  [_vModelSelect, filters.value.logStatus]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Search", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Search by log number, site...",
                  onInput: applyFilters
                }, null, 544), [
                  [_vModelText, searchQuery.value]
                ])
              ])
            ]),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("table", _hoisted_13, [
                    _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Log Number"),
                        _createElementVNode("th", null, "Tracking ID"),
                        _createElementVNode("th", null, "Site"),
                        _createElementVNode("th", null, "Category"),
                        _createElementVNode("th", null, "Priority"),
                        _createElementVNode("th", null, "Status"),
                        _createElementVNode("th", null, "Delivery Stats"),
                        _createElementVNode("th", null, "Requisition Manager"),
                        _createElementVNode("th", null, "Assigned To"),
                        _createElementVNode("th", null, "Scheduled Date"),
                        _createElementVNode("th", null, "Actual Date"),
                        _createElementVNode("th", null, "Log Status"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (filteredData.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[16] || (_cache[16] = [
                            _createElementVNode("td", {
                              colspan: "13",
                              class: "text-center"
                            }, "No records found", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.trackingId
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.logNumber), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.trackingId), 1)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.site?.name || '-'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(item.category), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(getPriorityBadgeClass(item.priority))
                            }, _toDisplayString(item.priority), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(getStatusBadgeClass(item.status))
                            }, _toDisplayString(item.status), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("small", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Total:", -1)),
                                _createTextVNode(" " + _toDisplayString(item.deliveryStats.totalEmployees), 1),
                                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Delivered:", -1)),
                                _createTextVNode(" " + _toDisplayString(item.deliveryStats.deliveredEmployees), 1),
                                _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Pending:", -1)),
                                _createTextVNode(" " + _toDisplayString(item.deliveryStats.pendingEmployees), 1),
                                _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Progress:", -1)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(getProgressClass(item.deliveryStats.completionPercentage))
                                }, _toDisplayString(item.deliveryStats.completionPercentage) + "% ", 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, _toDisplayString(item.requisitionManager?.name || '-'), 1),
                              _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("small", _hoisted_18, _toDisplayString(item.requisitionManager?.code || '-'), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (item.orderingAssignment?.assignedTo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("strong", null, _toDisplayString(item.orderingAssignment.assignedTo.name), 1),
                                  _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", _hoisted_20, _toDisplayString(item.orderingAssignment.assignedTo.code), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(formatDate(item.scheduledDeliveryDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(formatDate(item.actualDeliveryDate)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(getLogStatusBadgeClass(item.logStatus))
                            }, _toDisplayString(item.logStatus), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (viewDetails(item)),
                              title: "View Details"
                            }, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                            ]))], 8, _hoisted_22)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])),
            (filteredData.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, " Showing " + _toDisplayString(startIndex.value + 1) + " to " + _toDisplayString(endIndex.value) + " of " + _toDisplayString(filteredData.value.length) + " entries ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("nav", null, [
                      _createElementVNode("ul", _hoisted_27, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changePage(currentPage.value - 1)), ["prevent"]))
                          }, "Previous")
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["page-item", { active: page === currentPage.value }]),
                            key: page
                          }, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (changePage(page)), ["prevent"])
                            }, _toDisplayString(page), 9, _hoisted_28)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (changePage(currentPage.value + 1)), ["prevent"]))
                          }, "Next")
                        ], 2)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (showDetailsModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-modal-overlay",
          onClick: _withModifiers(closeDetailsModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "header-icon" }, [
                  _createElementVNode("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", { d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_32, [
                  _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "header-title" }, "Order Delivery Details", -1)),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(selectedItem.value?.logNumber), 1)
                ])
              ]),
              _createElementVNode("button", {
                class: "custom-close-btn",
                onClick: closeDetailsModal,
                type: "button"
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M6 18L18 6M6 6l12 12" })
                ], -1)
              ]))])
            ]),
            (selectedItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "status-label" }, "Order Status", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['status-value', getStatusClass(selectedItem.value.status)])
                        }, _toDisplayString(selectedItem.value.status), 3)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "status-label" }, "Log Status", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['status-value', getLogStatusClass(selectedItem.value.logStatus)])
                        }, _toDisplayString(selectedItem.value.logStatus), 3)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[33] || (_cache[33] = _createElementVNode("span", { class: "status-label" }, "Priority", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['status-value', getPriorityClass(selectedItem.value.priority)])
                        }, _toDisplayString(selectedItem.value.priority), 3)
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "status-label" }, "Category", -1)),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(selectedItem.value.category), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[41] || (_cache[41] = _createElementVNode("h3", { class: "section-title" }, [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", { d: "M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" })
                      ]),
                      _createTextVNode(" Delivery Progress ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "stat-icon total" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M13 7a4 4 0 11-8 0 4 4 0 018 0z" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "stat-label" }, "Total Employees", -1)),
                          _createElementVNode("span", _hoisted_46, _toDisplayString(selectedItem.value.deliveryStats.totalEmployees), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "stat-icon delivered" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_48, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "stat-label" }, "Delivered", -1)),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(selectedItem.value.deliveryStats.deliveredEmployees), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "stat-icon pending" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" })
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_51, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "stat-label" }, "Pending", -1)),
                          _createElementVNode("span", _hoisted_52, _toDisplayString(selectedItem.value.deliveryStats.pendingEmployees), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["progress-bar-fill", getProgressFillClass(selectedItem.value.deliveryStats.completionPercentage)]),
                          style: _normalizeStyle({ width: selectedItem.value.deliveryStats.completionPercentage + '%' })
                        }, [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(selectedItem.value.deliveryStats.completionPercentage) + "%", 1)
                        ], 6)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "section-title" }, [
                        _createElementVNode("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })
                        ]),
                        _createTextVNode(" Basic Information ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "info-key" }, "Log Number", -1)),
                          _createElementVNode("span", _hoisted_60, _toDisplayString(selectedItem.value.logNumber), 1)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "info-key" }, "Tracking ID", -1)),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(selectedItem.value.trackingId), 1)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "info-key" }, "Order ID", -1)),
                          _createElementVNode("span", _hoisted_64, _toDisplayString(selectedItem.value.orderId), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _cache[45] || (_cache[45] = _createElementVNode("span", { class: "info-key" }, "Expense Type", -1)),
                          _createElementVNode("span", _hoisted_66, _toDisplayString(selectedItem.value.expenseType), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _cache[49] || (_cache[49] = _createElementVNode("h3", { class: "section-title" }, [
                        _createElementVNode("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" }),
                          _createElementVNode("path", { d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z" })
                        ]),
                        _createTextVNode(" Site Information ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _cache[47] || (_cache[47] = _createElementVNode("span", { class: "info-key" }, "Site Name", -1)),
                          _createElementVNode("span", _hoisted_70, _toDisplayString(selectedItem.value.site?.name || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "info-key" }, "Site ID", -1)),
                          _createElementVNode("span", _hoisted_72, _toDisplayString(selectedItem.value.site?.id || '-'), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _cache[53] || (_cache[53] = _createElementVNode("h3", { class: "section-title" }, [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", { d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" })
                      ]),
                      _createTextVNode(" Team Members ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, _toDisplayString(getInitials(selectedItem.value.requisitionManager?.name)), 1),
                        _createElementVNode("div", _hoisted_77, [
                          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "member-role" }, "Requisition Manager", -1)),
                          _createElementVNode("span", _hoisted_78, _toDisplayString(selectedItem.value.requisitionManager?.name || '-'), 1),
                          _createElementVNode("span", _hoisted_79, _toDisplayString(selectedItem.value.requisitionManager?.code || '-'), 1),
                          (selectedItem.value.requisitionManager?.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(selectedItem.value.requisitionManager.email), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (selectedItem.value.orderingAssignment?.assignedTo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, _toDisplayString(getInitials(selectedItem.value.orderingAssignment.assignedTo.name)), 1),
                            _createElementVNode("div", _hoisted_83, [
                              _cache[51] || (_cache[51] = _createElementVNode("span", { class: "member-role" }, "Assigned To", -1)),
                              _createElementVNode("span", _hoisted_84, _toDisplayString(selectedItem.value.orderingAssignment.assignedTo.name), 1),
                              _createElementVNode("span", _hoisted_85, _toDisplayString(selectedItem.value.orderingAssignment.assignedTo.code), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (selectedItem.value.deliveryCompletedBy)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, _toDisplayString(getInitials(selectedItem.value.deliveryCompletedBy.name)), 1),
                            _createElementVNode("div", _hoisted_88, [
                              _cache[52] || (_cache[52] = _createElementVNode("span", { class: "member-role" }, "Delivered By", -1)),
                              _createElementVNode("span", _hoisted_89, _toDisplayString(selectedItem.value.deliveryCompletedBy.name), 1),
                              _createElementVNode("span", _hoisted_90, _toDisplayString(selectedItem.value.deliveryCompletedBy.code), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _cache[66] || (_cache[66] = _createElementVNode("h3", { class: "section-title" }, [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" })
                      ]),
                      _createTextVNode(" Timeline ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "timeline-marker" }, null, -1)),
                        _createElementVNode("div", _hoisted_94, [
                          _cache[54] || (_cache[54] = _createElementVNode("span", { class: "timeline-title" }, "Requisition Date", -1)),
                          _createElementVNode("span", _hoisted_95, _toDisplayString(formatDate(selectedItem.value.requisitionDate)), 1)
                        ])
                      ]),
                      (selectedItem.value.confirmation?.date)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                            _cache[57] || (_cache[57] = _createElementVNode("div", { class: "timeline-marker confirmed" }, null, -1)),
                            _createElementVNode("div", _hoisted_97, [
                              _cache[56] || (_cache[56] = _createElementVNode("span", { class: "timeline-title" }, "Confirmed", -1)),
                              _createElementVNode("span", _hoisted_98, _toDisplayString(formatDate(selectedItem.value.confirmation.date)), 1),
                              _createElementVNode("span", _hoisted_99, _toDisplayString(selectedItem.value.confirmation.status), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (selectedItem.value.orderPlacement?.placedDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "timeline-marker ordered" }, null, -1)),
                            _createElementVNode("div", _hoisted_101, [
                              _cache[58] || (_cache[58] = _createElementVNode("span", { class: "timeline-title" }, "Order Placed", -1)),
                              _createElementVNode("span", _hoisted_102, _toDisplayString(formatDate(selectedItem.value.orderPlacement.placedDate)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (selectedItem.value.orderingCompletedOn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "timeline-marker completed" }, null, -1)),
                            _createElementVNode("div", _hoisted_104, [
                              _cache[60] || (_cache[60] = _createElementVNode("span", { class: "timeline-title" }, "Ordering Completed", -1)),
                              _createElementVNode("span", _hoisted_105, _toDisplayString(formatDate(selectedItem.value.orderingCompletedOn)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_106, [
                        _cache[63] || (_cache[63] = _createElementVNode("div", { class: "timeline-marker scheduled" }, null, -1)),
                        _createElementVNode("div", _hoisted_107, [
                          _cache[62] || (_cache[62] = _createElementVNode("span", { class: "timeline-title" }, "Scheduled Delivery", -1)),
                          _createElementVNode("span", _hoisted_108, _toDisplayString(formatDate(selectedItem.value.scheduledDeliveryDate)), 1)
                        ])
                      ]),
                      (selectedItem.value.actualDeliveryDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _cache[65] || (_cache[65] = _createElementVNode("div", { class: "timeline-marker delivered" }, null, -1)),
                            _createElementVNode("div", _hoisted_110, [
                              _cache[64] || (_cache[64] = _createElementVNode("span", { class: "timeline-title" }, "Actual Delivery", -1)),
                              _createElementVNode("span", _hoisted_111, _toDisplayString(formatDate(selectedItem.value.actualDeliveryDate)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (selectedItem.value.remarks)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        _cache[67] || (_cache[67] = _createElementVNode("h3", { class: "section-title" }, [
                          _createElementVNode("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" })
                          ]),
                          _createTextVNode(" Remarks ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_113, _toDisplayString(selectedItem.value.remarks), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (selectedItem.value.cancellation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        _cache[69] || (_cache[69] = _createElementVNode("svg", {
                          width: "20",
                          height: "20",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_115, [
                          _cache[68] || (_cache[68] = _createElementVNode("span", { class: "alert-title" }, "Cancellation Details", -1)),
                          _createElementVNode("span", _hoisted_116, _toDisplayString(selectedItem.value.cancellation), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", { class: "custom-modal-footer" }, [
              _createElementVNode("button", {
                class: "custom-btn secondary",
                onClick: closeDetailsModal,
                type: "button"
              }, [...(_cache[70] || (_cache[70] = [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M6 18L18 6M6 6l12 12" })
                ], -1),
                _createTextVNode(" Close ", -1)
              ]))]),
              _cache[71] || (_cache[71] = _createElementVNode("button", {
                class: "custom-btn primary",
                type: "button"
              }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" })
                ]),
                _createTextVNode(" Print Details ")
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})